export const DEFAULT_COORDINATES = { lng: 37.620393, lat: 55.75396 };